import { render } from "./ModalPopup.vue?vue&type=template&id=6fa01078&scoped=true"
import script from "./ModalPopup.vue?vue&type=script&lang=js"
export * from "./ModalPopup.vue?vue&type=script&lang=js"

import "./ModalPopup.vue?vue&type=style&index=0&id=6fa01078&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6fa01078"

export default script